import React from 'react';
import ReactDOM from 'react-dom/client';
import "@fontsource/noto-sans-thai"
//import "@fontsource/noto-sans-thai-looped"
//import "@fontsource/k2d"
import "@fontsource/sarabun"
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
